// hooks/useRouteLogic.ts

'use client';

import { usePathname } from 'next/navigation';

export const useRouteLogic = () => {
  const pathname = usePathname();

  const showBonusOnRoute = pathname.startsWith('/sports') || pathname.startsWith('/casino');

  return { showBonusOnRoute };
};
